
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class ConfirmModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal'
  };

  @Prop({ default: false })
  private isShowModal!: boolean;

  @Prop({ default: '' })
  private imageUrl!: string;


  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventCloseModal, {
      data: null,
      close: true
    });
  }
}
